<div class="reset-password-page">
  <app-reset-password-form
    [code]="code"
    [showBorder]="true"
    (resetPasswordFormSubmit)="resetPasswordFormSubmit()"
    (backClick)="backClick()"
  ></app-reset-password-form>
</div>
